import {
    AgGridColumnDef,
    AgGridFilterType,
    FilterOption,
    SortOption
} from '@tassat/common-definitions';
import { APIConnectionRecord } from '@tassat/fred-definitions';

import { ApiConnectionCellRenderer } from 'SharedComponents/cellRenderComponent/apiConnectionAdminCellRenderer';

export type RowData = APIConnectionRecord;

const didApiConnectionUpdate = (apiConnectionA: APIConnectionRecord, apiConnectionB: APIConnectionRecord) => {
    if (!apiConnectionA) {
        return !apiConnectionB;
    } else {
        return apiConnectionA.APIConnectionName === apiConnectionB.APIConnectionName &&
            apiConnectionA.SourceId === apiConnectionB.SourceId &&
            apiConnectionA.IsLocked === apiConnectionB.IsLocked;
    }
};

export const getColumnDefs = (cellHeight: number): AgGridColumnDef[] => {
    return [
        {
            field: 'APIConnection',
            headerName: 'API Connections',
            cellRenderer: ApiConnectionCellRenderer,
            cellRendererParams: { cellHeight: cellHeight - 2 },
            valueGetter: (params) => params.data,
            equals: didApiConnectionUpdate,
            flex: 1
        },
        {
            field: 'APIConnectionName',
            colId: 'APIConnectionName',
            filter: 'agTextColumnFilter',
            hide: true
        },
        {
            field: 'IsLocked',
            colId: 'IsLocked',
            filter: 'agTextColumnFilter',
            hide: true
        },
        {
            field: 'IsDeleted',
            colId: 'IsDeleted',
            filter: 'agTextColumnFilter',
            hide: true
        }
    ];
};

export const apiConnectionSortOptions: SortOption[] = [
    {
        title: 'Connection Name',
        colId: 'APIConnectionName'
    },
    {
        title: 'Is Locked',
        colId: 'IsLocked'
    },
    {
        title: 'Is Deleted',
        colId: 'IsDeleted'
    },
    {
        title: 'Clear Sort',
        colId: 'clear'
    }
];

export const apiConnectionFilterOptions: FilterOption[] = [
    {
        title: 'Locked Connections',
        colId: 'IsLocked',
        type: AgGridFilterType.Equal,
        filter: 'true'
    },
    {
        title: 'Deleted Connections',
        colId: 'IsDeleted',
        type: AgGridFilterType.Equal,
        filter: 'true'
    },
    {
        title: 'Clear Filter',
        colId: 'clear',
        type: AgGridFilterType.ClearFilter,
        filter: 'clear'
    }
];